// extracted by mini-css-extract-plugin
export default {"root":"root--7a4eb1c","value":"value--5d230ed","progressBar":"progressBar--5e5c427","isRunning":"isRunning--2145061"};